import { createFocusTrap } from 'focus-trap'
import { getElOrFalse } from './utils'

export class Modal {
    outer: HTMLElement
    inner: HTMLElement
    closeBtn: HTMLButtonElement
    triggers: HTMLElement[] = []
    trap: ReturnType<typeof createFocusTrap>
    contents: { [key: string]: HTMLElement } = {}

    constructor(outer: HTMLElement) {
        this.outer = outer
        this.inner = outer.querySelector('.sp-modal__dialog') || this.createDialog()
        this.closeBtn = outer.querySelector('button.sp-modal__close') || this.createCloseButton()
        this.trap = createFocusTrap(this.inner, {
            clickOutsideDeactivates: false,
            escapeDeactivates: false,
            allowOutsideClick: true,
            returnFocusOnDeactivate: false,
            preventScroll: false,
            initialFocus: false,
        })

        this.addListener()
    }

    createDialog() {
        let dialog = document.createElement('div')
        dialog.classList.add('sp-modal__dialog')
        this.outer.appendChild(dialog)
        return dialog
    }

    createCloseButton() {
        let btn = document.createElement('button')
        btn.classList.add('sp-modal__close')
        btn.setAttribute('aria-label', 'Close modal')
        this.inner.appendChild(btn)
        return btn
    }

    addTriggers(triggers: HTMLElement[]) {
        triggers.forEach((trigger) => {
            let id = trigger.getAttribute('data-modal')
            let contents = document.getElementById(id)
            if (!contents) return

            this.triggers.push(trigger)
            this.contents[id] = contents
            contents.remove()
            contents.style.display = 'block'
            trigger.classList.add('sp-modal__open')
        })
    }

    addListener = () => {
        document.addEventListener('click', this.handleClick)
        this.closeBtn.addEventListener('click', this.closeModal)
    }

    handleClick = (e: MouseEvent) => {
        if (e.target == this.outer) return this.closeModal()

        let toggleBtn = (e.target as HTMLElement).closest('.sp-modal__open')
        if (toggleBtn) {
            let id = toggleBtn.getAttribute('data-modal')
            if (id) this.openModal(id)
        }
    }

    keydown = (e: KeyboardEvent) => {
        if (e.key === 'Escape') this.closeModal()
    }

    openModal = (id: string) => {
        let contents = this.contents[id]
        if (!contents) return

        this.inner.appendChild(contents)
        document.documentElement.style.overflow = 'hidden'

        this.outer.style.display = 'flex'
        setTimeout(() => {
            this.outer.classList.add('sp-modal--open')
            this.inner.focus()
            this.trap.activate()
        })
        window.addEventListener('keydown', this.keydown)
    }

    closeModal = () => {
        let contents = this.inner.querySelector('.sp-modal__content')

        this.outer.classList.remove('sp-modal--open')
        this.trap.deactivate()
        document.documentElement.style.overflow = 'auto'
        setTimeout(() => {
            this.outer.style.display = 'none'
            contents.remove()
        }, 300)

        if (contents) {
            let id = contents.getAttribute('id')
            console.log(id)
            if (id) {
                let trigger = getElOrFalse(document.querySelector(`[data-modal="${id}"]`))
                console.log({ trigger })
                trigger && trigger.focus()
            }
        }
        window.removeEventListener('keydown', this.keydown)
    }
}
